import { Notifier } from '@airbrake/browser';
import packfile from '~/package.json';

const airbrake = new Notifier({
  projectId: 278969,
  projectKey: 'd50afab3d7b1ed3d4a9379a9a63543bf',
  environment: process.env.NODE_ENV,
});

const pkage = JSON.parse(JSON.stringify(packfile));
const name = pkage.name;
const version = pkage.version;

export default function sendToNotifier(
  title: string,
  errorMessage: string,
  context?: any
) {
  if (process.env.NODE_ENV === 'production') {
    airbrake.notify({
      error: title,
      context: {
        component: 'APEJSClient',
        version: name + ' ' + version,
        ...context,
      },
      session: { session1: errorMessage },
    });

    window.newrelic.noticeError(title, {
      component: 'JSClient',
      version: name + ' ' + version,
      ...context,
      session: errorMessage,
    });
  } else {
    console.info(
      'DEV: Writing to console (Production will send to notifier).\r\n',
      title.replace(/[\r\n]+/g, ' '),
      '\r\n',
      errorMessage.replace(/[\r\n]+/g, ' ')
    );
  }
}

// send error with extra context
export function sendToNotifierWithExtra(
  error: Error,
  errorType: string,
  session: string,
  context?: any
) {
  error.name = `${errorType}: ${error.name}`;
  if (process.env.NODE_ENV === 'production') {
    airbrake.notify({
      error,
      context: {
        component: 'APEJSClient',
        version: name + ' ' + version,
        ...context,
      },
      session: { session1: session },
    });
    window.newrelic.noticeError(error, {
      component: 'JSClient',
      version: name + ' ' + version,
      ...context,
      session: { session1: session },
    });
  } else {
    console.info(
      'DEV: Writing to console (Production will send to notifier).\r\n',
      error.message,
      '\r\n',
      session
    );
  }
}
